import { SupplyTypes } from '../../config';

interface ISuppliesFromMemberStateOfIdentification {
  vat_return_supply_id: number;
  supply_type: string;
  supply_type_id: number;
  consumer_id: number;
  consumer: string;
  vat_rate_id: number;
  vat_rate: number;
  vat_rate_type: string;
  taxable_amount: number;
  vat_amount: number;
}

interface ISuppliesFromFixedEstablishments {
  vat_return_supply_id: number;
  supply_type: string;
  supply_type_id: number;
  consumer_id: number;
  consumer: string;
  vat_rate_id: number;
  vat_rate: number;
  vat_rate_type: string;
  taxable_amount: number;
  vat_amount: number;
  fixed_establishment: number;
}

export const calculateTotalVatAmount = (
  items: Array<
    ISuppliesFromMemberStateOfIdentification | ISuppliesFromFixedEstablishments
  >,
  supply_type: SupplyTypes
) => {
  let count = 0;
  for (let item of items) {
    if (item.supply_type_id === supply_type) count += item.vat_amount;
  }
  return count;
};
